module.exports = __webpack_public_path__ + "img/weixinPay.39b353f0.png";